var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"items_container"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"b",on:{"click":function($event){return _vm.onURL(1)}}},[_vm._v("五福临门")]),_c('p',{on:{"click":function($event){return _vm.onURL(2)}}},[_vm._v("八方来财")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }